import { loadable } from '@elliemae/pui-app-sdk';

export const LoadableDeepLink = loadable(
  () =>
    import(
      /* webpackChunkName: "login" */ /* webpackPrefetch: true */ './deepLink'
    ),
  null, // use wait message from html
);
